module.exports = __webpack_public_path__ + "tables/media/Charts_filled.c8bdf8be.svg";